import type { RouteObject } from "react-router-dom";
import AppShell from "@/components/feature/AppShell";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Login from "@/pages/login/page";
import Notifications from "@/pages/notifications/page";
import Salary from "@/pages/salary/page";
import SystemSettings from "@/pages/system-settings/page";
import OperationLog from "@/pages/operation-log/page";
import ClockInRecord from "@/pages/clock-in-record/page";
import MyApplications from "@/pages/my-applications/page";
import Employees from "@/pages/employees/page";
import Profile from "@/pages/profile/page";

import RBAC from "@/pages/rbac/page";
import Products from "@/pages/products/page";
import Shipping from "@/pages/shipping/page";
import Accounting from "@/pages/accounting/page";
import KnowledgeBase from "@/pages/knowledge-base/page";
import ManagerCenter from "@/pages/manager-center/page";
import CustomerService from "@/pages/customer-service/page";
import DepartmentChat from "@/pages/department-chat/page";

const routes: RouteObject[] = [
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/",
    element: <AppShell />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/products",
        element: <Products />,
      },
      {
        path: "/shipping",
        element: <Shipping />,
      },
      {
        path: "/accounting",
        element: <Accounting />,
      },
      {
        path: "/manager-center",
        element: <ManagerCenter />,
      },
      {
        path: "/customer-service",
        element: <CustomerService />,
      },
      {
        path: "/chat",
        element: <div className="p-8 text-center text-foreground-500">即時客服頁面開發中</div>,
      },
      {
        path: "/department-chat",
        element: <DepartmentChat />,
      },
      {
        path: "/employees",
        element: <Employees />,
      },
      {
        path: "/rbac",
        element: <RBAC />,
      },
      {
        path: "/knowledge-base",
        element: <KnowledgeBase />,
      },
      {
        path: "/profile",
        element: <Profile />,
      },
      {
        path: "/notifications",
        element: <Notifications />,
      },
      {
        path: "/salary",
        element: <Salary />,
      },
      {
        path: "/system-settings",
        element: <SystemSettings />,
      },
      {
        path: "/operation-log",
        element: <OperationLog />,
      },
      {
        path: "/clock-in-record",
        element: <ClockInRecord />,
      },
      {
        path: "/my-applications",
        element: <MyApplications />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;